import './AgentBannerStyle.less';

import * as React from 'react';

import { Icon } from '@opendoor/bricks';
import { trackEvent } from '../../api/analytics';
import { EventTrackingCategory } from '../../declarations';

export interface IAgentInfoBannerIProps {
  title: string;
  description: string;
  learnMoreHref: string;
  isAnnouncement: boolean;
  icon?: string;
  source?: string;
  analyticsIdentifier?: EventTrackingCategory;
}

export class AgentInformationBanner extends React.PureComponent<IAgentInfoBannerIProps> {
  public render(): JSX.Element {
    const { icon, title, description, isAnnouncement, learnMoreHref, source } = this.props;
    return (
      <div className="banner-container">
        <div className="od-agent-offer-banner">
          <div className="agent-offer-banner">
            {isAnnouncement && (
              <div className="banner-pill">
                <span className="pill-text">Announcement</span>
              </div>
            )}
            {icon && (
              <div className="banner-icon-container">
                <Icon className="od-agent-resale-landing-page__bonus-commission-icon" name={icon} />
              </div>
            )}
            <div>
              <div className="banner-subheader">{title}</div>
              <div className="banner-text-body">{description}</div>
              <div>
                <a
                  href={learnMoreHref}
                  target="_blank"
                  onClick={() => {
                    source && this.trackClickEvent('get-an-offer');
                  }}
                >
                  Learn more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  private trackClickEvent(clickEvent) {
    const { source, analyticsIdentifier } = this.props;
    analyticsIdentifier && trackEvent(analyticsIdentifier, 'click', clickEvent, { source });
  }
}

export default AgentInformationBanner;
